export enum DepositState {
  BORROWED = 'BORROWED',
  RETURNED = 'RETURNED',
  ON_HOLD = 'ON_HOLD'
}
